/**
 * A stock's daily closes as a line, drawn in code (SVG string). prices: [{date: 'Y-m-d', close}], oldest first.
 */
const fmtDate = d => new Date(d + 'T00:00:00Z').toLocaleDateString('en-GB', {
  day: 'numeric',
  month: 'short',
  year: 'numeric',
  timeZone: 'UTC'
});
const money = v => '₦' + Number(v).toLocaleString('en-US', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2
});

/** fmt writes a value for the screen-reader summary (₦ with kobo by default; the market total passes a compact one) */
export function priceChart(prices, fmt = money) {
  const W = 600,
    H = 220,
    L = 8,
    R = 8,
    T = 16,
    B = 26;
  const closes = prices.map(p => p.close);
  let min = Math.min(...closes);
  let max = Math.max(...closes);
  if (max === min) {
    max += max * 0.02 || 1;
    min -= min * 0.02 || 1;
  }
  const x = i => L + (W - L - R) * i / Math.max(1, prices.length - 1);
  const y = v => T + (H - T - B) * (1 - (v - min) / (max - min));
  const up = closes[closes.length - 1] >= closes[0];
  const colour = up ? 'var(--vmk-up,#12805c)' : 'var(--vmk-down,#c62828)';
  const line = prices.map((p, i) => (i ? 'L' : 'M') + x(i).toFixed(1) + ' ' + y(p.close).toFixed(1)).join(' ');
  const area = line + ' L' + x(prices.length - 1).toFixed(1) + ' ' + (H - B) + ' L' + x(0).toFixed(1) + ' ' + (H - B) + ' Z';
  const hi = closes.indexOf(Math.max(...closes));
  const lo = closes.indexOf(Math.min(...closes));
  const label = (fmt === money ? 'Closing price' : 'Value') + ' from ' + fmtDate(prices[0].date) + ' (' + fmt(closes[0]) + ') to ' + fmtDate(prices[prices.length - 1].date) + ' (' + fmt(closes[closes.length - 1]) + '); high ' + fmt(closes[hi]) + ', low ' + fmt(closes[lo]) + '.';
  return `<svg class="VouchaMk-chart" viewBox="0 0 ${W} ${H}" preserveAspectRatio="none" role="img" aria-label="${label}" xmlns="http://www.w3.org/2000/svg">` + `<path d="${area}" fill="${colour}" opacity="0.10"/>` + `<path d="${line}" fill="none" stroke="${colour}" stroke-width="2" vector-effect="non-scaling-stroke" stroke-linejoin="round"/>` + `<line x1="${L}" x2="${W - R}" y1="${H - B}" y2="${H - B}" stroke="var(--control-bg,#e5e5e5)" vector-effect="non-scaling-stroke"/>` + `</svg>`;
}
export { fmtDate, money };
flarum.reg.add('voucha-markets', 'forum/components/PriceChart', { priceChart: priceChart,fmtDate: fmtDate,money: money, });